import type { NetworkPayload } from "../../../composites";
import type { WebDocument } from "./types";

export const API = {
  createShareDocuments: (
    documents: WebDocument[],
  ): NetworkPayload<{ documents: WebDocument[] }> => {
    return {
      url: "documents/download?share=1",
      options: {
        method: "POST",
        payload: { documents },
        isJsonResponse: true,
      },
    };
  },
};
